import React from "react";

import { capitalize } from "Util/capitalize";

import { TestResults, TestWarnings } from "../../../../types";
import { round } from "../../../../util/round";
import { Row, Typography } from "../shared";

const row: Row = {
  label: "Expected Audio Quality (MOS)",
  getValue: (testResults: TestResults) => {
    const quality = testResults.results.preflight?.callQuality;
    const mos = testResults.results.preflight?.stats?.mos?.average;

    if (quality && mos) {
      return `${capitalize(quality)} (${round(mos)})`;
    }
  },
  getWarning: (testResults: TestResults) =>
    testResults.results.preflight?.warnings.some((warning) => warning.name === "low-mos")
      ? TestWarnings.warn
      : TestWarnings.none,
  tooltipContent: {
    label: (
      <Typography>
        Expected audio quality is calculated from jitter, latency, and packet loss measured. A
        measure of 3.5 and above is needed for good user experience.
      </Typography>
    ),
  },
};

export default row;
